import { useQuery } from "@apollo/client"
import { GET_HOMES } from "../graphql/Home/HOME_GQL"
import { findContentByLabel } from "../utils/findContentByLabel"
import { useMemo } from "react"

const SectionTitles = ({ className = "" }) => {
  const { data } = useQuery(GET_HOMES)
  const ContentData = data?.homes

  const titles = useMemo(() => ({
    section2Title1: findContentByLabel(ContentData, "section2_title1") || "",
    section2Title2: findContentByLabel(ContentData, "section2_title2") || "",
    section2Title3: findContentByLabel(ContentData, "section2_title3") || ""
  }), [ContentData])

  return (
    <div className={className}>
      <h5>{titles.section2Title1}</h5>
      <h2>{titles.section2Title2}</h2>
      <h5>{titles.section2Title3}</h5>
    </div>
  )
}

export default SectionTitles
